<twc-autocomplete id="share-project-recipients" customInput multiple [ngModel]="chips"
    (ngModelChange)="onChanges($event)"></twc-autocomplete>
<div class="msg-error" *ngIf="errorMsg">
    <small>
        {{ errorMsg }}
    </small>
</div>
<div *ngIf="!errorMsg && hintMsg">
    <small>
        {{ hintMsg }}
    </small>
</div>